"use client";

import { motion } from "motion/react";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { GlassCard } from "@/src/components/GlassCard";
import { ImageWithFallback } from "@/src/components/figma/ImageWithFallback";

// * ─── Experience / About Section ─────────────────────────────────────────────
export function HomeExperienceSection() {
  const { t } = useTranslation("common");

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-transparent to-walnut-50/30 dark:to-walnut-950/30">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-walnut-900 dark:text-white mb-6">
              {t("experience.title")}
            </h2>
            <p className="text-lg text-walnut-700 dark:text-walnut-300 mb-6">
              {t("experience.content1")}
            </p>
            <p className="text-lg text-walnut-700 dark:text-walnut-300 mb-8">
              {t("experience.content2")}
            </p>
            <Link
              href="/about"
              className="inline-flex items-center gap-2 text-walnut-700 dark:text-walnut-300 hover:text-walnut-900 dark:hover:text-white font-semibold group"
            >
              {t("experience.learnMore")}
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <GlassCard className="p-0 overflow-hidden">
              <ImageWithFallback
                src="https://images.unsplash.com/photo-1739204618173-3e89def7140f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb3JydWdhdGVkJTIwY2FyZGJvYXJkJTIwYm94ZXMlMjB3YXJlaG91c2V8ZW58MXx8fHwxNzcxNjA3OTQ1fDA&ixlib=rb-4.1.0&q=80&w=1080"
                alt="Packaging warehouse"
                className="w-full h-96 object-cover"
              />
            </GlassCard>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
